export class AppPermissions {
	static balance = '1BD7A3D1_R';
	static transactionHistory = '21AC2749_R';
	static entitlementCheck = 'F7EDFE26_R';
	static onlineTransactions = '731A7D18_R';

	static addBalance = '596C88CB_R';
	static changeLocation = 'AA10F6ED_R';

	static reports = 'B7A57568_R';
	static totalRegister = 'F6C3B3DE';

	static dtaCommunityConnect = 'B8287186';
}